export default {
  ACTIVE_CLASS: 'panel__view--active'
};
